/* svd-lp-magbalans-4tecken.js
   Ersätter PageFlys scroll-till-sektion, som låg i appens pagefly-helper.js
   (app embed). Utan den här filen slutar sidans fyra CTA-knappar fungera när
   PageFly avinstalleras.

   Knapparna bär data-to-section="<id>" och scrollar till det element som har
   data-section-id="<id>". data-offset är JSON med brytpunkter; PageFly använde
   50px överallt på den här sidan, men vi läser fältet i stället för att anta. */
(function () {
  'use strict';

  function offsetFor(el) {
    var raw = el.getAttribute('data-offset');
    if (!raw) return 0;
    try {
      var o = JSON.parse(raw);
      var w = window.innerWidth;
      if (w < 768 && o.mobile != null) return Number(o.mobile) || 0;
      if (w < 1025 && o.tablet != null) return Number(o.tablet) || 0;
      if (w < 1200 && o.laptop != null) return Number(o.laptop) || 0;
      return Number(o.all) || 0;
    } catch (e) {
      return 0;
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-to-section]');
    if (!trigger) return;

    var id = trigger.getAttribute('data-to-section');
    var target = document.querySelector('[data-section-id="' + id + '"]');
    if (!target) return;

    event.preventDefault();
    var top = target.getBoundingClientRect().top + window.scrollY - offsetFor(trigger);
    window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
  });
})();
